<!-- ONE-PAGE FULLSCREEN ERROR -->
<div class="error-screen" style="
background-position: top center;
  display: block;
    min-height: 100vh;


    background-image: url('assets/img/backgroundLarger.webp');


  ">
  <!-- HEADER -->
  <header class="site-header">
    <a href="https://www.hep.hr/" target="_blank" class="logo-link">
      <img src="assets/img/bijeliHepLogo.svg" alt="HEP logo" class="logo">
    </a>

    <nav class="nav-links" *ngIf="postsService.natjecaj">
      <a *ngIf="postsService.natjecaj.natjecajDocLink" [href]="postsService.natjecaj.natjecajDocLink" class="mob"
        target="_blank">
        o natječaju
      </a>

      <span *ngIf="postsService.natjecaj.natjecajDocLink
              && postsService.natjecaj.natjecajUputeLink" style="color: #c62828;">|</span>

      <a *ngIf="postsService.natjecaj.natjecajUputeLink" [href]="postsService.natjecaj.natjecajUputeLink" class="mob"
        target="_blank">
        upute
      </a>
      <span *ngIf="postsService.natjecaj.natjecajUputeLink
              && postsService.natjecaj.natjecajFaqLink" style="color: #c62828;">|</span>
      <a *ngIf="postsService.natjecaj.natjecajFaqLink" [href]="postsService.natjecaj.natjecajFaqLink" class="mob"
        target="_blank">
        pitanja
      </a>
    </nav>

  </header>
  <!-- GLAVNI SADRŽAJ (centrirana kartica) -->
  <main class="error-container" style="margin-top:27px">
    <section
      *ngIf="spremanjeStatus === 'ERROR' || postsService.spremanjeStatus === 'EXISTS' || ['EXISTS','EXPIRED','INVALID','ERROR'].includes(tokenStatus) || (postsService.spremanjeStatus === '' && postsService.tokenStatus === '') ;else empty">
      <div class="error-card">
        <ng-container *ngIf="spremanjeStatus === 'ERROR'">
          <h2>Prijavnica nije poslana.</h2>
        </ng-container>

        <ng-container *ngIf="postsService.spremanjeStatus === 'EXISTS'" >
          <h2>{{ postsService.spremanjePoruka }}</h2>
          <p>Prijavnica nije poslana.</p>
        </ng-container>


        <ng-container *ngIf="postsService.status === 'ERROR'">
       
          <p>Došlo je do greške. Molimo pokušajte ponovo kasnije.</p>
        </ng-container>


        <ng-container *ngIf="postsService.status != 'ERROR'&&['EXISTS','EXPIRED','INVALID','ERROR'].includes(tokenStatus)">
          <h2>{{ postsService.tokenPoruka }}</h2>
          <p>Kliknite na gumb za slanje nove poveznice.</p>
        </ng-container>

        <ng-container *ngIf="postsService.status != 'ERROR'&&postsService.spremanjeStatus === '' && postsService.tokenStatus === ''">
          <h2>Kliknite na gumb za slanje nove poveznice.</h2>
        </ng-container>

        <form  *ngIf="postsService.status != 'ERROR'" (ngSubmit)="enterEmail()" #emailForm="ngForm" >
          <button type="submit" class="btn btn-primary" [disabled]="emailForm.invalid">
            Povratak na slanje poveznice
          </button>
        </form>
      </div>
    </section>



    <ng-template #empty>
      <div *ngIf="postsService.status != 'ERROR'" class="error-card">
      


        <ng-container >
          <h2>Kliknite na gumb za slanje nove poveznice.</h2>
        </ng-container>

        <form (ngSubmit)="enterEmail()" #emailForm="ngForm">
          <button type="submit" class="btn btn-primary" [disabled]="emailForm.invalid">
            Povratak na slanje poveznice
          </button>
        </form>
      </div>
    </ng-template>


  </main>

  <!-- FOOTER -->
  <footer class="site-footer">
    <p>Hrvatska elektroprivreda d.d. <span class="sep">|</span> Ulica grada Vukovara 37
      <span class="sep">|</span> 10 000 Zagreb
    </p>
  </footer>

</div>
